<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    underTracking: boolean;
    size?: number | string;
    color?: string;
    icon?: string;
  }>(),
  {
    size: "small",
    color: "",
    icon: "mdi-crosshairs-gps"
  },
);
</script>

<template>
  <div v-if="props.underTracking">
    <v-tooltip location="top">
      <template #activator="{ props: underTrackingProps }">
        <v-icon :color="color" :icon="icon" :size="size" class="ml-2" v-bind="underTrackingProps"></v-icon>
      </template>
      Under tracking
    </v-tooltip>
  </div>
</template>
